import contactAPI from "../../api/contact";
import types from "../types";

// initial state
const state = {
  ids: [],
  entities: {},
};

const getContacts = (state) => state.ids.map((id) => state.entities[id]);

// getters
const getters = {
  [types.getters.contacts]: getContacts,
  [types.getters.contact]: (state) => (contactID) => state.entities[contactID],
  [types.getters.primaryContact]: (state) =>
    getContacts(state).find((contact) => contact.isPrimaryContact),
};

// actions
const actions = {
  [types.actions.updateContactField](
    { commit },
    { contactID, fieldName, value },
  ) {
    commit(types.mutations.updateContactField, { contactID, fieldName, value });
  },
  [types.actions.updateContactsRemote](
    { commit },
    { contacts, showLoader = true },
  ) {
    const changedContacts = contacts.filter((contact) => contact.isDirty);
    if (!changedContacts.length) {
      return Promise.resolve();
    }

    showLoader && commit(types.mutations.setIsLoading, { isLoading: true });

    return contactAPI
      .updateContacts(changedContacts)
      .then((res) => {
        commit(types.mutations.resetContactsDirtyFlag);
        return res;
      })
      .finally(() => {
        showLoader &&
          commit(types.mutations.setIsLoading, { isLoading: false });
      });
  },
};

// mutations
const mutations = {
  [types.mutations.setContacts](state, contacts) {
    state.ids = contacts.map((contact) => contact.contactID);
    state.entities = contacts
      .map((contact) => {
        if (contact.pastGuest && contact.pastGuest.length) {
          // pastGuest is an array now
          contact.hasPastGuest = contact.pastGuest.some(
            (pastGuest) => !!pastGuest,
          );
        } else {
          contact.hasPastGuest = false;
        }
        contact.hasSameResidentialAddress = !!contact.hasSameResidentialAddress;
        contact.hasSameEmergencyContact = !!contact.hasSameEmergencyContact;
        contact.hasSamePrePostArrangement = !!contact.hasSamePrePostArrangement;
        return contact;
      })
      .reduce((accumulate, contact) => {
        accumulate[contact.contactID] = contact;
        return accumulate;
      }, {});
  },
  [types.mutations.updateContactField](state, { contactID, fieldName, value }) {
    state.entities[contactID][fieldName] = value;
    state.entities[contactID].isDirty = true;
  },
  [types.mutations.resetContactsDirtyFlag](state) {
    getContacts(state).forEach((entity) => (entity.isDirty = false));
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/contact.js